import React, { Component } from 'react';
import { observer } from 'mobx-react';
import UsersStore from 'Stores/usersStore'
import UsersRequests from 'Utils/Requests/UsersRequests';
import IconsContainer from "Utils/IconsContainer";
import 'Styles/usersView/DeviceDbModal.scss';

class DeviceDbModal extends Component {
    constructor(props) {
        super(props);

        this.deviceCode = props.deviceCode;
    }

    render() {
        return (
            <div className="device-db-modal">
                <div/>
                {UsersStore.GetDeviceDbDumps(this.deviceCode).map(dumpInfo => (
                    <div
                        key={`dbDump_${dumpInfo.title}`}
                        className='db-modal-line smr-table-line'
                    >
                        <div className='db-modal-cell'>{IconsContainer.Get('us-folders-menu')}</div>
                        <div className='db-modal-cell db-modal-cell-text'>{dumpInfo.title}</div>
                        <div className='db-modal-cell db-modal-cell-buttons'>
                            <button className="red-button" onClick={() => UsersStore.DeleteDeviceDataDump(dumpInfo)}>Удалить</button>
                            <button onClick={() => UsersRequests.DownloadDeviceDbDump(dumpInfo)}>Выгрузить</button>
                        </div>
                    </div>
                ))}
            </div>
        );
    }
}

export default observer(DeviceDbModal);